angular.module('gym.components').directive('skipSequenceCondition', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/sequences/skip_sequence_condition.html.slim'),
    replace: true,
    scope: {
      sequence: '=',
      step: '=',
      condition: '=',
      index: '=',
      removeCondition: '&',
      reports: '='
    },
    controller: ["$scope", function($scope) {
      $scope.remove = function() {
        return $scope.removeCondition({
          step: $scope.step,
          index: $scope.index
        });
      };
      $scope.isConditionDisplaying = function() {
        return $scope.condition.type === 'LinkedReportSkipSequenceCondition';
      };
      return $scope.displayReportName = function() {
        var report;
        report = _.findWhere($scope.reports, {
          id: $scope.condition.report_id
        });
        return report.name;
      };
    }]
  };
});
